import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ProposalState } from 'src/app/_enums/proposal.enums';
import { ProposalService } from 'src/app/_services/proposal.service';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { ActionModalComponent } from '../../action-modal/action-modal.component';

@Component({
  selector: 'app-send-proposals-modal',
  templateUrl: './send-proposals-modal.component.html',
  styleUrls: ['./send-proposals-modal.component.css'],
  standalone: true,
  imports: [CommonModule, ActionModalComponent, IconsModule, FormsModule],
})
export class SendProposalsModalComponent {
  private _proposals: ProposalDetails[] = [];

  withoutNotification = false;

  @Input()
  displayTrigger = true;

  @Input()
  set proposals(value: ProposalDetails[]) {
    this._proposals = value;
    if (value && value.length > 0) {
      this.canSend = value.some(
        (x) => x.proposalState === ProposalState.PROPOSAL_SAVED
      );
    } else {
      this.canSend = false;
    }
  }

  get proposals() {
    return this._proposals;
  }

  submitted = false;

  canSend = false;

  @Output()
  proposalsSent = new EventEmitter();

  @ViewChild('actionModal')
  modal: ActionModalComponent;

  constructor(
    private readonly proposalService: ProposalService,
    private readonly toastrService: ToastrService
  ) {}

  openSendModal() {
    this.withoutNotification = false;
    this.modal.openModal();
  }

  sendAllProposals() {
    const proposalsToSendIds = this.proposals
      ?.filter((x) => x.proposalState === ProposalState.PROPOSAL_SAVED)
      .map((x) => x.proposalId);
    if (
      this.submitted ||
      !proposalsToSendIds ||
      proposalsToSendIds.length === 0
    ) {
      return;
    }
    this.submitted = true;
    const formdata = {
      proposalIds: proposalsToSendIds,
      ...(this.withoutNotification ? { withoutNotification: true } : {}),
    };
    this.proposalService._sendProposal(formdata).subscribe({
      next: () => {
        this.toastrService.success($localize`Offres envoyées avec succès`);
        this.proposalsSent.emit();
        this.modal.closeModal();
        this.withoutNotification = false;
        this.submitted = false;
      },
      error: (err) => {
        this.toastrService.error(
          err?.error?.error?.clientErrorMessage ??
            $localize`Une erreur est survenue lors de l'envoi des offres`
        );
        this.withoutNotification = false;
        this.submitted = false;
      },
    });
  }
}
